export default "__VITE_ASSET__DX1KPik1__"